module.exports = __webpack_public_path__ + "static/media/logo.6db32437.png";